import './ContentIssues.sass';

import React from 'react';

import ReviewBlock from '../ReviewBlock/ReviewBlock';

/**
 * Builds the heading for a content issues block, e.g.
 * getContentIssuesLabel('answer A') -> 'The answer A text does not comply with:'
 */
export const getContentIssuesLabel = (field) =>
  `The ${field} text does not comply with:`;

/** Reads the option letter out of an answer title such as 'Option A (Correct)'. */
export const getAnswerIssuesField = (title) => {
  const letter =
    typeof title === 'string' ? (title.match(/Option ([A-D])/) || [])[1] : null;
  return letter ? `answer ${letter}` : 'answer';
};

/**
 * Lists the content rules a field does not comply with (quotes, duplicate
 * answers, missing question mark). Renders nothing when the field is clean.
 */
export default function ContentIssues({
  messages,
  label = getContentIssuesLabel('response'),
}) {
  const issues = messages || [];

  if (issues.length === 0) return null;

  return (
    <ReviewBlock label={label} className="content-issues">
      {issues.map((message) => (
        <div className="content-issue" key={message}>
          {message}
        </div>
      ))}
    </ReviewBlock>
  );
}
